module.exports = __webpack_public_path__ + "static/media/skateboarding.46c8cc1e.jpg";